import { Organization } from '@/shared/api/protocol-ts/model/dto_organization_pb';

export const getOrganizationPrintName = (organization?: Organization) =>
  organization?.PrintName || organization?.Name;
